import { testimonials } from '@/mocks/data';

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-foreground-800"></span>
              <span className="text-foreground-600 text-xs font-label tracking-wider uppercase">用户口碑</span>
            </div>
            <blockquote className="mb-6">
              <span className="font-heading text-7xl md:text-9xl text-primary-500 leading-none select-none">&ldquo;</span>
              <p className="font-heading text-xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight -mt-6 md:-mt-10">
                全网最专业的吃瓜导航，每日更新网红黑料、最新爆料视频，吃瓜群众在线观看不迷路。
              </p>
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="font-heading font-bold text-foreground-900 text-sm">51在线吃瓜团队</span>
              <span className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                  </span>
                ))}
              </span>
              <span className="tag-pill bg-accent-100 text-accent-700 font-label">已认证</span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=dramatic%20black%20and%20white%20portrait%20of%20Chinese%20person%20side%20profile%20looking%20up%20high%20contrast%20magazine%20editorial%20style%20minimal%20background%20strong%20shadows%20artistic%20fashion%20photography&width=600&height=800&seq=testimonial-portrait&orientation=landscape"
                alt="用户口碑"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-12 md:mt-16">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center">
                  <i className={`${t.avatar} text-foreground-500 text-lg`}></i>
                </div>
                <span className="font-label font-medium text-foreground-900 text-sm">{t.name}</span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed font-label">
                &ldquo;{t.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}